import React, { useEffect, useRef } from 'react';
/*import {
  GoogleMap,
  DrawingManagerF,
  PolygonF,
  useJsApiLoader,
} from '@react-google-maps/api';
import config from '../config';*/


//const MAP_LIBRARIES = ['drawing', 'places','marker'];

const LocationAutocomplete = ({ onSelect, isLoaded, loadError }) => {
  const containerRef = useRef(null);
  const placeAutoCompleteElementRef = useRef(null); // Keep for instance tracking

  /*const { isLoaded, loadError } = useJsApiLoader({
          id: 'google-map-script',
          googleMapsApiKey: config.googleApiKey,
          libraries: MAP_LIBRARIES,
          region: 'IN',
          version: 'weekly',
        });
  */
  useEffect(() => {
    if (!isLoaded) return;

    const currentContainerRef = containerRef.current;
    let placeElInstance = null; 

    const initPlaceElement = async () => {
      try {
        if (!window.google || !window.google.maps || !window.google.maps.importLibrary) {
          console.error("Google Maps JavaScript API not loaded.");
          return;
        }
        const placesLibrary = await window.google.maps.importLibrary('places');

        if (!currentContainerRef) {
            console.error("Autocomplete container ref is not available.");
            return;
        }

        if (currentContainerRef.getAttribute('data-initialized') === 'true') {
          return;
        }

        placeElInstance = new placesLibrary.PlaceAutocompleteElement({
          includedRegionCodes: ['in'],
        });
        
        placeAutoCompleteElementRef.current = placeElInstance;

        // Apply shadcn/ui-like styling to the HOST <gmp-place-autocomplete> element
        // Based on your ui-ux-reference.txt for an Input component [cite: 1, 20]
        placeElInstance.className = 'flex items-center h-10 w-full rounded-md  border-input bg-background px-0 py-0 text-sm text-foreground ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';

        const handleSelect = async (event) => {
          const placePrediction = event.placePrediction || (event.detail && event.detail.placePrediction);
          if (!placePrediction) {
            console.warn("No placePrediction found in gmp-select event", event);
            return;
          }

          const place = placePrediction.toPlace();
          await place.fetchFields({ 
            fields: ['formattedAddress', 'addressComponents', 'location', 'id'] 
          });

          const getComponent = (type) => {
            const match = place.addressComponents?.find?.(c => c.types?.includes(type));
            return match?.longText || '';
          };

          const locationData = {
            sublocality_level_2: getComponent('sublocality_level_2'),
            sublocality_level_1: getComponent('sublocality_level_1'),
            locality: getComponent('locality'),
            district: getComponent('administrative_area_level_3'),
            post_code: getComponent('postal_code'),
            state: getComponent('administrative_area_level_1'),
            country: getComponent('country'),
            latitude: place.location?.lat(),
            longitude: place.location?.lng()
          };
          const formattedAddress = place.formattedAddress;
          
          onSelect(locationData, formattedAddress);

          const internalInput = placeElInstance.shadowRoot?.querySelector('input');
          if (internalInput) {
            internalInput.value = formattedAddress;
          } else if (placeElInstance.value !== undefined) {
            placeElInstance.value = formattedAddress;
          }
        };
        placeElInstance.addEventListener('gmp-select', handleSelect);

        if (!currentContainerRef.firstChild) {
          currentContainerRef.appendChild(placeElInstance);
          currentContainerRef.setAttribute('data-initialized', 'true');

          // CRITICAL: Style the INTERNAL input within the Shadow DOM
          // This ensures it fits perfectly within the styled host and doesn't cause overflow.
          const styleInternalInputElement = () => {
            if (placeElInstance && placeElInstance.shadowRoot) {
              const internalInput = placeElInstance.shadowRoot.querySelector('input');
              if (internalInput) {
                // Force reset and full conformance to host
                internalInput.style.setProperty('width', '100%', 'important');
                internalInput.style.setProperty('height', '100%', 'important'); // Fill host's h-10
                internalInput.style.setProperty('box-sizing', 'border-box', 'important');
                internalInput.style.setProperty('min-width', '0', 'important');
                
                // Remove any conflicting visual styles from the internal input itself.
                // The host element's styles (px-3, py-2, border, bg-background) will provide the visuals.
                internalInput.style.setProperty('padding', '0', 'important');
                internalInput.style.setProperty('border', 'none', 'important');
                internalInput.style.setProperty('background', 'transparent', 'important');
                internalInput.style.setProperty('outline', 'none', 'important');

                // Ensure text styling is consistent
                internalInput.style.setProperty('font-size', 'inherit', 'important');
                internalInput.style.setProperty('color', 'inherit', 'important');
                internalInput.style.setProperty('line-height', 'inherit', 'important'); // Helps with vertical text alignment

              } else {
                // Retry if shadow DOM's input isn't immediately available
                // console.warn("Internal input not found yet, retrying to style.");
                // setTimeout(styleInternalInputElement, 50);
              }
            }
          };
          
          // Attempt styling after a brief delay to ensure shadow DOM is ready.
          // requestIdleCallback is a good option if available, otherwise setTimeout.
          if (window.requestIdleCallback) {
            window.requestIdleCallback(styleInternalInputElement, { timeout: 500 });
          } else {
            setTimeout(styleInternalInputElement, 50); // Increased delay slightly for robustness
          }

        } else {
           console.warn('Autocomplete container already had content during init.');
        }

      } catch (err) {
        console.error('❌ Failed to initialize Google Place Autocomplete Element:', err);
      }
    };

    if (window.google?.maps?.places) {
      initPlaceElement();
    } else {
      console.warn("Google Maps Places API not immediately available.");
    }

    return () => {
      if (currentContainerRef) {
          currentContainerRef.removeAttribute('data-initialized');
          // Consider more robust cleanup if placeElInstance was appended
          if (placeElInstance && currentContainerRef.contains(placeElInstance)) {
             // currentContainerRef.removeChild(placeElInstance); // This might be too aggressive if React reuses the container.
                                                              // Clearing innerHTML or letting React handle unmount might be okay.
          }
      }
      placeAutoCompleteElementRef.current = null;
    };
  }, [onSelect]);

  return (
    <div className="relative w-full">
      {/* This div hosts the Google element. Its w-full is good. */}
      <div ref={containerRef} className="w-full">
        {/* The Google PlaceAutocompleteElement is appended here. */}
      </div>
    </div>
  );
};

export default LocationAutocomplete;